import { Subscription } from 'rxjs/Subscription';
import { Flp360StatusEnum } from '../enums';
import { BaseSettings } from 'src/app/common/component-settings/base-settings.model';

export class Flp360LoginComponentSettings extends BaseSettings {
    flp360StatusEnum = Flp360StatusEnum;
    flp360LoginSubscription: Subscription;
    verifiedFlp360UserInfo: any;
}
